if (!customElements.get('cbm-recently-viewed')) {
  const STORAGE_KEY = 'cbm:recently-viewed';
  const MAX_STORED = 12;

  const readHandles = () => {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };

  const writeHandles = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {}
  };

  customElements.define(
    'cbm-recently-viewed',
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-recent-grid]');
        const current = this.dataset.current;
        const limit = parseInt(this.dataset.limit, 10) || 4;
        const history = readHandles().filter((h) => h !== current);

        this.querySelector('[data-recent-clear]')?.addEventListener('click', () => {
          writeHandles(current ? [current] : []);
          this.hidden = true;
          this.grid.innerHTML = '';
        });

        if (current && !window.Shopify?.designMode) writeHandles([current, ...history]);
        this.render(history.slice(0, limit + 2), limit);
      }

      async render(handles, limit) {
        if (!handles.length) return;
        const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

        const cards = await Promise.all(
          handles.map(async (handle) => {
            try {
              const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=cbm-recent-card`);
              if (!response.ok) return null;
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              return doc.querySelector('[data-recent-card]');
            } catch (e) {
              return null;
            }
          })
        );

        const found = cards.filter(Boolean).slice(0, limit);
        if (!found.length) return;

        const missing = handles.filter((h, i) => !cards[i]);
        if (missing.length) writeHandles(readHandles().filter((h) => !missing.includes(h)));

        found.forEach((card) => {
          const item = document.createElement('li');
          item.className = 'grid__item';
          item.innerHTML = card.innerHTML;
          this.grid.appendChild(item);
        });
        this.hidden = false;
      }
    }
  );
}
